import React from 'react';

import { Button, Upload, message, Row, Col } from 'antd';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';

import getColors from 'get-image-colors'
import { t } from '../../../i18n';

const { Dragger } = Upload;
// const getColors = require('get-image-colors')

const UploadImage = (props) => {

  const draggerProps = {
    name: 'file',
    multiple: false,
    listType: "picture",
    maxCount: 1,
    showUploadList: false,
    //set color of the dragger
    // onChange(info) {
    //   const { status } = info.file;
    //   if (status !== 'uploading') {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (status === 'done') {
    //     message.success(`${info.file.name} file uploaded successfully.`);
    //   } else if (status === 'error') {
    //     message.error(`${info.file.name} file upload failed.`);
    //   }
    // },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };



  const fitToContainer = (imageWidth, imageHeight) => {
    const canvasScroll = document.getElementById("canvasScroll");
    const containerWidth = canvasScroll.offsetWidth;
    const containerHeight = canvasScroll.offsetHeight;


    var scaledImageHeight = imageHeight;
    var scaledImageWidth = imageWidth;

    let scale = Math.min(
      containerWidth / imageWidth,
      containerHeight / imageHeight
    );



    if (scale < 1) {
      scaledImageHeight = Math.floor(imageHeight * scale);
      scaledImageWidth = Math.floor(imageWidth * scale);
      props.setScale(scale);
      console.log("the scale is: ",scale);
    }

    return [scaledImageWidth, scaledImageHeight];
  }

  const handleUpload = (event) => {
    if (event.type != "image/jpeg" && event.type != "image/png" && event.type != "image/gif") {
      message.error(t("{type} file type is not accepted").replace("{type}", event.type));
      return;
    }



    console.log(event)
    props.setFile(event)

    getColors(URL.createObjectURL(event), {count: 2, type: event.type}).then(colors => {
      // const hexColorHtml = ;
      console.log("colors, ", colors)
      const colorButton = document.getElementById("addColor");
      colors.map(color => {
        document.getElementById("status").innerHTML = color.hex()
        colorButton.click();
      });
      // props.setColors( colors.map(color => [color.hex().slice(1),true]))
    })

    const img = new Image();
    img.onload = function () {
      // const str = img.toString('base64');
      // const buffer = Buffer.from(str,'base64');

      const canvas = document.getElementById("canvas");

      const [imgWidth, imgHeight] = fitToContainer(img.width, img.height);

      // if the image resolution is greater then 1920 by 1080, warn the user of the wait time
      
      // if the image width*height is less than 600x600, advertise pro version
      if (img.width*img.height < 600*600 ) {
        props.setIsAIModalVisible(true);
      }

      if (img.width*img.height >2073600 ) {
        props.setLargeImageWarning(true);
      } else {
        props.setLargeImageWarning(false);
      }

      canvas.width = imgWidth;
      canvas.height = imgHeight;

      props.setCrop(
        {
          unit: 'px', // Can be 'px' or '%'
          x: 0,
          y: 0,
          width: img.width,
          height: img.height
        }
      )

      canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height, 0, 0, imgWidth, imgHeight);
      props.setImageDimensions([img.width, img.height]);
      props.setDespeckle(img.width * 0.01);
    }

    img.src = URL.createObjectURL(event);
  }

  return (

    <Dragger {...draggerProps}
      action={handleUpload}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{t("Click or drag file to this area to upload")}</p>
      <p className="ant-upload-hint">
        {t("Upload any PNG or JPEG image you want to convert")}
      </p>
    </Dragger>

    // <Upload
    //   action={handleUpload}
    //   listType="picture"
    //   maxCount={1}
    //   showUploadList={false}

    // >
    //   <Button style={{ marginBottom: "10px", marginRight: "10px" }} icon={<UploadOutlined />}>Upload</Button>
    // </Upload>
  );
};

export default UploadImage;